import { render, staticRenderFns } from "./huifu.vue?vue&type=template&id=bb45dc30&scoped=true&"
import script from "./huifu.vue?vue&type=script&lang=js&"
export * from "./huifu.vue?vue&type=script&lang=js&"
import style0 from "./huifu.vue?vue&type=style&index=0&id=bb45dc30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb45dc30",
  null
  
)

export default component.exports